import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const steps = ["Create account", "Activate organization"];

const ProgressCard = styled(Paper)(({ theme }) => ({
  margin: theme.spacing(0, "auto", 4),
  maxWidth: 720,
  padding: theme.spacing(3),
  textAlign: "left",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
  },
}));

const ProgressHeader = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));
const StepCount = styled(Typography)(() => ({
  fontWeight: 700,
}));

type OfficerOnboardingProgressProps = {
  activeStep: 0 | 1;
  organizationName: string;
};

export default function OfficerOnboardingProgress({
  activeStep,
  organizationName,
}: Readonly<OfficerOnboardingProgressProps>) {
  return (
    <ProgressCard elevation={2}>
      <ProgressHeader>
        <StepCount color="primary" variant="overline">
          Step {activeStep + 1} of {steps.length}
        </StepCount>
        <Typography component="h1" variant="h5">
          Set up your AttorneyHub workspace
        </Typography>
        <Typography color="text.secondary" variant="body2">
          Complete these steps to activate {organizationName}.
        </Typography>
      </ProgressHeader>
      <Box component="nav" aria-label="Onboarding progress">
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    </ProgressCard>
  );
}
